import { Alert, Box, Typography, useLayout } from '@capitalise/ui-design-system';
import useDisplayFundingSearchDriver, {
  FundingSearchDriverPosition,
} from 'modules/Business/hooks/useDisplayFundingSearchDriver';
import { ScoreGrade } from 'modules/Business/shared/typesTS';
import { useRef } from 'react';
import AnimatedToggleBox from './AnimatedToggleBox';
import DriverSidePanel from './DriverSidePanel';
import FundingDriverExperian from 'assets/images/funding-driver-experian.png';

const FundingSearchDriver = ({
  position,
  creditScore,
}: {
  position: FundingSearchDriverPosition;
  creditScore?: ScoreGrade;
}) => {
  const ref = useRef();
  const { setRightBarOverlay } = useLayout();
  const { visible, removeBanner } = useDisplayFundingSearchDriver({ position, ref, creditScore });

  const openSidePanel = () => {
    setRightBarOverlay(<DriverSidePanel />, { size: 'xlarge' });
  };

  return (
    <AnimatedToggleBox ref={ref} open={visible} overflow="hidden">
      <Box mt="xsmall">
        <Alert
          type="info"
          closable
          actionLabel="More info"
          onActionClick={openSidePanel}
          onCloseClick={removeBanner}
          image={FundingDriverExperian}
          spacing="3xsmall"
          actionVariant="outlined"
        >
          <Box flexDirection="column" flexPosition="start start">
            <Typography size="heading-22" color="grey-900">
              See your full Experian business credit profile as banks and lenders see it.
            </Typography>
          </Box>
        </Alert>
      </Box>
    </AnimatedToggleBox>
  );
};

export default FundingSearchDriver;
